import { computed } from "vue";
import { useAccessGrantStore } from "../stores";
export function useAccessGrants() {
    const store = useAccessGrantStore();
    return {
        grants: computed(() => store.grants),
        newlyIssuedGrant: computed(() => store.newlyIssuedGrant),
        isLoading: computed(() => store.isLoading),
        error: computed(() => store.error),
        load: (orgId) => store.load(orgId),
        issue: (orgId, allowedOrigins, captchaRequired) => store.issue(orgId, allowedOrigins, captchaRequired),
        revoke: (orgId, grantId) => store.revoke(orgId, grantId),
        acknowledgeNewlyIssuedGrant: () => store.acknowledgeNewlyIssuedGrant(),
    };
}
